<!-- Header section -->
<login-header></login-header>
<div class="gradient_bg">
  <div class="unsubscribe_container">
    <div class="unsub_section">
      @if (!showForm) {
        <div class="unsub_form mt-5 text-center" style="height: 260px;">
          <div class="fc_form_heading mb-3">
            <h2>You've successfully been unsubscribed from Family Central marketing emails</h2>
          </div>
        </div>
      }
      @if (showForm) {
        <div class="unsub_form">
          <div class="fc_form_heading text-center mb-3">
            <h2>Please enter your details to unsubscribe.</h2>
          </div>
          <div class="mt-4 fc_form_wrapper">
            <div class="fc_form_area">
              <form class="fc_form" [formGroup]="submitform">
                <div class="form-group mb-3">
                  <label for="email" class="form-label"><span class="required">*</span>Email</label>
                  <input id="email" name="email" formControlName="email" maxlength="50" id="inviteEmail" class="form-control"
                    type="text" placeholder="Enter email address" required />
                  </div>
                  <div class="form-group mb-3">
                    <label for="name" class="form-label"><span class="required">*</span>Choose Reason</label>
                    <select class="form-select" id="unsub_reasons" formControlName="unsubscribeReasons">
                      <option value="" disabled="" selected="selected">Select Reason</option>
                      <option value="Your emails are not relevant to me">Your emails are not relevant to me</option>
                      <option value="Your emails are too frequent">Your emails are too frequent</option>
                      <option value="I don't remember signing up for this">I don't remember signing up for this</option>
                      <option value="I no longer want to receive these emails">I no longer want to receive these emails</option>
                      <option value="Others">Others</option>
                    </select>
                  </div>
                  <div class="form-group d-flex justify-content-between align-items-center mt-4 mb-0">
                    <button type="button" class="border_btn">Cancel</button>
                    <button type="button" disableduringajax="" [disabled]="submitform.invalid" (click)="submit()" class="primary_btn">Unsubscribe</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  <!-- Footer Section -->
  <app-footer></app-footer>